exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-center[data-v-1a91728a]{display:-webkit-box;display:-ms-flexbox;display:flex}", ""]);

// exports
